import React from "react";
import BaseViewController from "./base-view-controller";
import { VideoRoomComponent } from "../components/video-room-component";
import { createThumbnail, fileToImage } from "../utils/images";
import {
  IMAGE_UPLOAD_COMPLETE_SCREEN_NAME,
  IMAGE_UPLOAD_INFO_SCREEN_NAME,
  PHOTO_MODAL_SCREEN_NAME,
  VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER,
  VIDEO_ROOM_PHOTO_MODAL_SCREEN_NAME,
  getScreenNameComparator
} from "../utils/video-room-helper";

class VideoRoomViewController extends BaseViewController {
  constructor(props) {
    super(props);

    this.extraVideoRoomProps = {};

    /**
     * [Cigna] (01.09.21):
     * These fields are left for future purpose to implement all business logic for uploading images as it is on mobile
     * At this moment only 'addImageScreen' is using for displaying of uploading files dialog
     */
    this.addImageScreen = this.appData.data.screens.find(
      getScreenNameComparator(PHOTO_MODAL_SCREEN_NAME)
    );
    this.imageUploadScreen = this.appData.data.screens.find(
      getScreenNameComparator(IMAGE_UPLOAD_INFO_SCREEN_NAME)
    );
    this.imageUploadCompleteScreen = this.appData.data.screens.find(
      getScreenNameComparator(IMAGE_UPLOAD_COMPLETE_SCREEN_NAME)
    );

    if (this.imageUploadScreen) {
      this.extraVideoRoomProps.imageUploadScreen = this.imageUploadScreen;
    }

    if (this.addImageScreen) {
      const updatedAddImageScreen = {
        ...this.addImageScreen,
        name: VIDEO_ROOM_PHOTO_MODAL_SCREEN_NAME
      };

      this.extraVideoRoomProps.addImageScreen = updatedAddImageScreen;
    }
  }

  preprocessScreenData() {
    /**
     * [Cigna] TO DO (01.09.21):
     * Find out what purpose of fetching consult_status and its logic
     * Can be permanently removed if this logic is unnecessary
     */
    // if (this.appData.consultStatus.hasOwnProperty("status_text")) {
    const { childScreens } = this.screen;
    const [childScreen] = childScreens;
    /**
     * [Cigna] TO DO (01.09.21):
     * Temporary remove all chieldFields(according to Tips logic that is not implemented yet)
     */
    // const updatedChildScreenFields = childScreen.fields.map(field => {
    //   return field.name === "consultStateText" ? { ...field, title: this.appData.consultStatus.status_text } : field
    // });
    if (!this.appData.consultStatus.status_text) {
      this.appData.consultStatus.status_text = childScreen?.fields.find(
        field => field.name === "consultStateText"
      )?.title;

      const updatedChildScreenFields =
        this.screen?.childScreens[0].fields ?? [];
      const updatedScreenFields = this.screen?.fields ?? [];

      this.screen = {
        ...this.screen,
        fields: updatedScreenFields,
        childScreens: [
          {
            ...childScreen,
            fields: updatedChildScreenFields
          }
        ]
      };
    } else {
      this.appData.updateConsultState();
    }
  }

  handleButtonClick(name) {
    /**
     * [Cigna] To Do (01.09.21):
     * Ensure this logic is necessary (addImageButton, tipTitle), otherwise just remove it!
     */
    if (name === "addImageButton") {
      const photoUploadControl = document.getElementById(
        "video-room-image-upload"
      );
      photoUploadControl.value = "";
      this.appData.handleChange({
        [`__${VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER}:photoPreview`]: null,
        [`__${VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER}:photoName`]: ""
      });
      photoUploadControl.click();
      return;
    }

    if (name === "tipTitle") {
      const elements = document.getElementsByClassName(
        "show-hide-element-web-sdk"
      );
      elements.forEach(el => {
        if (el.style.display === "block") {
          el.style.display = "none";
        } else {
          // if not "block", e.g. "none" or undefined
          el.style.display = "block";
        }
      });
    }
  }

  handleImageUpload(e) {
    const [file] = e.target.files;
    const fieldName = `__${VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER}:photoPreview`;
    fileToImage(file)
      .then(image => createThumbnail(image, 500, 500))
      .then(thumbnail => {
        this.appData.handleChange({
          [fieldName]: { file, thumbnails: { 500: thumbnail } }
        });
      });
  }

  handleBackButtonClick() {
    this.onExitVideoRoomHandler(super.handleBackButtonClick.bind(this));
  }

  setOnExitVideoRoomHandler = callBack => {
    this.onExitVideoRoomHandler = callBack;
  };

  renderScreen() {
    const { childScreens, data } = this.screen;
    const [childScreen] = childScreens;
    const childScreenRender = super.renderScreen({
      screen: childScreen,
      isRoot: true
    });

    return (
      <>
        {childScreenRender}
        <VideoRoomComponent
          {...this.extraVideoRoomProps}
          config={data.video_auth_details[this.appData.values.consult_id]}
          statusPollingConfig={data?.statusPollingConfig || {}}
          components={this.components}
          appData={this.appData}
          // to make the dialog upload rerender when a field that needs validation changes
          // TODO consider dialog internals to redux so it will know about state changes for free
          setOnExitVideoRoomHandler={this.setOnExitVideoRoomHandler}
          onClose={this.appData.onExit}
        />
        <div hidden>
          <input
            id='video-room-image-upload'
            type='file'
            accept='.jpg,.jpeg,.png,.gif'
            onChange={this.handleImageUpload.bind(this)}
          />
        </div>
      </>
    );
  }
}

export default VideoRoomViewController;
